// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"_jLvE","navigation":"F8MHo","navigationItem":"_2ZhIY","navigationItemLink":"_3pFyI","active":"EeFFW"};